import styled from 'styled-components';

import { basicSmallTextStyle, Button, colorsMatrix } from '@dreryk/react-components';

type StyledEmergencyNotificationButtonProps = Readonly<{
   $active: boolean;
}>;

export const StyledEmergencyNotificationButton = styled(Button)<StyledEmergencyNotificationButtonProps>`
   ${basicSmallTextStyle};
   position: relative;
   padding: 5px 10px 5px 33px;
   height: 30px;

   ${({ theme, $active }) => `
      color: ${theme.white};
      background: ${$active ? theme.secondary : theme.error};
      border: ${$active ? theme.secondary : theme.error};
      &:not(:disabled):hover {
         color: ${theme.white};
         background: ${$active ? theme.secondaryDark : theme.errorDark};
         border: ${$active ? theme.secondaryDark : theme.errorDark};
      }
   `}

   svg {
      fill: ${colorsMatrix.grey.lightest};
      position: absolute;
      top: 2px;
      left: 8px;
      width: 24px;
      height: 24px;
   }
`;

StyledEmergencyNotificationButton.displayName = 'StyledEmergencyNotificationButton';

export const SmallIconWrapper = styled.span`
   display: inline-flex;

   && svg {
      width: 20px;
      height: 20px;
      top: 4px;
      left: 10px;
   }
`;

SmallIconWrapper.displayName = 'SmallIconWrapper';
